<app-breadcrumb [title]="'Dashboard'" [breadcrumb]="'Dashboard'"></app-breadcrumb>
<!-- section start -->
<section class="section-b-space">
    <div class="container">
        <div class="col-lg-12">
            <section class="section-b-space">
                <div class="checkout-page">
                    <div class="checkout-form">
                        <form>
                            <div class="row">
                                <div class="col-lg-12 col-sm-12 col-xs-12">
                                    <div class="checkout-title">
                                        <div class="row check-out">
                                            <h4>Filtros</h4>

                                            <div class="typo-content input_button">
                                                <div>
                                                    <input type="radio" [(ngModel)]="tipoFiltro" [value]="'emissao'"
                                                        name="filtro-group" id="filtro-1" checked>
                                                    <label for="filtro-1">Data de Emissão</label>
                                                </div>
                                                <div>
                                                    <input type="radio" [(ngModel)]="tipoFiltro" [value]="'tour'"
                                                        name="filtro-group" id="filtro-2">
                                                    <label for="filtro-2">Data Tour</label>
                                                </div>
                                                <div>
                                                    <input type="radio" [(ngModel)]="tipoFiltro" [value]="'passageiro'"
                                                        name="filtro-group" id="filtro-3">
                                                    <label for="filtro-3">Passageiro</label>
                                                </div>
                                                <div>
                                                    <input type="radio" [(ngModel)]="tipoFiltro" [value]="'idvendapesquisa'"
                                                        name="filtro-group" id="filtro-4">
                                                    <label for="filtro-4">ID Venda</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row check-out" *ngIf="tipoFiltro == 'emissao'">
                                        <div class="form-group col-md-3 col-sm-6 col-xs-12">
                                            <div class="field-label">Data Inicial</div>
                                            <div class="input-group">
                                                <input class="form-control" placeholder="dd/mm/aaaa" name="dataInicial"
                                                    [(ngModel)]="dataInicialModel" ngbDatepicker #d="ngbDatepicker" />
                                                <button class="btn btn-outline-secondary calendar" (click)="d.toggle()"
                                                    type="button"><i-feather class="feather-sm"
                                                        name="calendar"></i-feather>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3 col-sm-6 col-xs-12">
                                            <div class="field-label">Data Final</div>
                                            <div class="input-group">
                                                <input class="form-control" placeholder="dd/mm/aaaa" name="dataFinal"
                                                    [(ngModel)]="dataFinalModel" ngbDatepicker #dd="ngbDatepicker" />
                                                <button class="btn btn-outline-secondary calendar" (click)="dd.toggle()"
                                                    type="button"><i-feather class="feather-sm"
                                                        name="calendar"></i-feather>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3 col-sm-12 col-xs-12">
                                            <div class="field-label">Produto</div>
                                            <select name="produto" [(ngModel)]="produtoSelected">
                                                <option *ngFor="let prod of produtosBase" value="{{prod.id}}">
                                                    {{prod.nome}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-3 col-sm-12 col-xs-12">
                                            <div class="field-label">Status</div>
                                            <select name="status" [(ngModel)]="statusSelected">
                                                <option value=""> - Todos</option>
                                                <option *ngFor="let status of statusItems" value="{{status}}">
                                                    {{status}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row check-out" *ngIf="tipoFiltro == 'tour'">
                                        <div class="form-group col-md-3 col-sm-6 col-xs-12">
                                            <div class="field-label">Data Tour</div>
                                            <div class="input-group">
                                                <input class="form-control" placeholder="dd/mm/aaaa" name="dataInicial"
                                                    [(ngModel)]="dataInicialModel" ngbDatepicker #d="ngbDatepicker" />
                                                <button class="btn btn-outline-secondary calendar" (click)="d.toggle()"
                                                    type="button"><i-feather class="feather-sm"
                                                        name="calendar"></i-feather>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="form-group col-md-3 col-sm-12 col-xs-12">
                                            <div class="field-label">Status</div>
                                            <select name="status" [(ngModel)]="statusSelected">
                                                <option value=""> - Todos</option>
                                                <option *ngFor="let status of statusItems" value="{{status}}">
                                                    {{status}}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-3 col-sm-12 col-xs-12">
                                            <div class="field-label">Produto</div>
                                            <select name="produto" [(ngModel)]="produtoSelected">
                                                <option *ngFor="let prod of produtosBase" value="{{prod.id}}">
                                                    {{prod.nome}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="row check-out" *ngIf="tipoFiltro == 'passageiro'">
                                        <div class="form-group col-md-6 col-sm-12 col-xs-12">
                                            <div class="field-label">Passageiro</div>
                                            <input class="form-control" placeholder="Nome do Passageiro"
                                                name="passageironome" [(ngModel)]="passageironome"/>
                                        </div>
                                    </div>
                                    <div class="row check-out" *ngIf="tipoFiltro == 'idvendapesquisa'">
                                        <div class="form-group col-md-6 col-sm-12 col-xs-12">
                                            <div class="field-label">ID Venda</div>
                                            <input class="form-control" placeholder="Número da venda" name="idvendapesquisa"
                                                [(ngModel)]="idvendapesquisa" />
                                        </div>
                                    </div>
                                    <button class="btn-solid btn" (click)="onSubmit();">
                                        Pesquisar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <table class="table cart-table table-responsive-xs">
                        <thead>
                            <tr class="table-head">
                                <th scope="col">
                                    <p>ID</p>
                                </th>
                                <th scope="col">
                                    <p>Data</p>
                                </th>
                                <th scope="col">
                                    <p>Valor</p>
                                </th>
                                <th scope="col">
                                    <p>Situação</p>
                                </th>
                                <th scope="col">
                                    <p>Atividades</p>
                                </th>
                                <th scope="col">
                                    <p>Produto</p>
                                </th>
                                <th scope="col">
                                    <p>Saída</p>
                                </th>
                                <th scope="col">
                                    <p>Passageiros</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let venda of vendasBase">
                                <td>
                                    <p>{{venda.id}}</p>
                                </td>
                                <td>
                                    <p>{{venda.dataVencimento | date: 'shortDate'}}</p>
                                </td>
                                <td>
                                    <p>{{venda.valor | currency:'BRL':'symbol'}}</p>
                                </td>
                                <td>
                                    <p>{{venda.status}}</p>
                                </td>
                                <td>
                                    <a href="javascript: void(0);" class="link me-2"
                                        (click)="imprimirComprovante(venda.id)" placement="top"
                                        ngbTooltip="Imprimir Comprovante">
                                        <i-feather name="file-text" class="feather-sm"></i-feather>
                                    </a>
                                    <button class="btn btn-outline-primary" type="button" hidden><i-feather
                                            class="feather-sm" name="edit"></i-feather>
                                    </button>
                                    <button class="btn text-primary" (click)="copiarlink(venda)" type="button"
                                        *ngIf="venda.status == 'Aguardando Pagamento pelo Link'"><i-feather
                                            class="feather-sm" name="link" ngbTooltip="Copiar Link Pagamento"></i-feather>
                                    </button>
                                    <button class="btn text-primary" (click)="cancelar(venda)" type="button"
                                        *ngIf="venda.status != 'Cancelado' && venda.diasAntesDeExecutar > 2"><i-feather
                                            class="feather-sm" name="trash" ngbTooltip="Cancelar"></i-feather>
                                    </button>
                                    <button class="btn text-primary"
                                        (click)="enviarEmailModal(venda, 'comprovante', null)" type="button"
                                        *ngIf="venda.status != 'Cancelado'">
                                        <i-feather class="feather-sm" name="send" ngbTooltip="Enviar Comprovante"></i-feather>
                                    </button>
                                    <!-- <button class="btn btn-outline-primary" (click)="faturado(venda)"
                                        type="button" *ngIf="venda.status != 'Faturado'"><i-feather class="feather-sm" name="check"></i-feather>
                                    </button> -->
                                </td>
                                <td>
                                    <p *ngFor="let prod of venda.produtosVendidos">{{prod.nome}}</p>
                                </td>
                                <td>
                                    <p *ngFor="let prod of venda.produtosVendidos">{{prod.tarifa.data.data | date:
                                        'shortDate'}}</p>
                                </td>
                                <td>
                                    <p *ngFor="let prod of venda.produtosVendidos">{{prod.passageiros.length}}</p>
                                </td>
                                <td>
                                    <p *ngFor="let prod of venda.produtosVendidos">
                                        <a href="javascript: void(0);" class="link me-2"
                                            (click)="imprimirVoucher(prod.id)" placement="top"
                                            ngbTooltip="Imprimir Voucher">
                                            <i-feather name="file-text" class="feather-sm"></i-feather>
                                        </a>
                                        <button class="btn text-primary"
                                            (click)="enviarEmailModal(venda, 'voucher', prod.id)" type="button"
                                            *ngIf="venda.status != 'Cancelado'">
                                            <i-feather class="feather-sm" name="send"></i-feather>
                                        </button>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
<ng-template #esperaModal let-modal>
    <div class="modal-body">
        <form>
            <div class="mb-3 row">
                <h3 class="text-center">Os dados estão sendo gerados.</h3>
                <h4 class="text-center">Aguardo um momento por favor.</h4>
                <div [@spin]="spinState">
                    <i-feather name="clock" class="feather-sm"></i-feather>
                </div>
            </div>
        </form>
    </div>
</ng-template>
<!-- section end -->
<app-passageiro #passageiro [productVenda]="productVenda"></app-passageiro>
<app-cancelarvenda #cancelarVenda [vendaSelected]="vendaSelected"></app-cancelarvenda>
<app-enviaremail #enviarEmail [vendaSelected]="vendaSelected"></app-enviaremail>